import { render, staticRenderFns } from "./ConfiguracionAlarmas.vue?vue&type=template&id=641b40a2&"
import script from "./ConfiguracionAlarmas.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionAlarmas.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionAlarmas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports